import { render, staticRenderFns } from "./DialogMunicipalityProviders.vue?vue&type=template&id=21087e1e&scoped=true&"
import script from "./DialogMunicipalityProviders.vue?vue&type=script&lang=js&"
export * from "./DialogMunicipalityProviders.vue?vue&type=script&lang=js&"
import style0 from "./DialogMunicipalityProviders.vue?vue&type=style&index=0&id=21087e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21087e1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21087e1e')) {
      api.createRecord('21087e1e', component.options)
    } else {
      api.reload('21087e1e', component.options)
    }
    module.hot.accept("./DialogMunicipalityProviders.vue?vue&type=template&id=21087e1e&scoped=true&", function () {
      api.rerender('21087e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogMunicipalityProviders.vue"
export default component.exports